import { getResource } from '../utilities/service-utils'

export const getAllCarriers = () => {
  return getResource('carrier')
}

export const getPilotCarriers = () => {
  return getResource('carrier/carrier-pilot')
}
